import { Component } from '@angular/core';
import { StorageService } from './shared/services/StorageService';
import { Directionality } from '@angular/cdk/bidi';
import { MatDialog } from '@angular/material/dialog';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  title = 'OSA';
  public version: string = packageJson.version;
  styleReady = false;

  constructor(
    public storageService: StorageService,
    private appDir: Directionality,
    private dialog: MatDialog
  ) {
    this.storageService.changes.subscribe(data => {
      if (data?.key == 'language' || data?.key == 'authUser') {
        window.location.reload();
      }
    });

    // Load file style based on language
    let lang = localStorage.getItem('language') || 'en';
    localStorage.setItem('language', lang);
    const direction = lang === 'ar' ? 'rtl' : 'ltr';
    let style = lang === 'ar' ? 'assets/css/ar-SA/style.css' : 'assets/css/en-US/style.css';
    let buildNumber = this.version;
    style += buildNumber ? '?vr=' + buildNumber : '';
    document.getElementById('html')?.setAttribute('lang', lang);
    document.getElementById('html')?.setAttribute('dir', direction);
    (this.appDir as any).value = direction;


    this.waitForStylesheet(style)
      .then(() => {
        this.styleReady = true;
      })
      .catch(err => {
        console.error(err);
        this.styleReady = true;
      });

    // Listen for ALL dialogs opening
    this.dialog.afterOpened.subscribe(() => {
      const dialogRef = this.dialog.openDialogs[this.dialog.openDialogs.length - 1];
      console.log(dialogRef);

      if (!dialogRef) return;

      // Listen for backdrop click
      dialogRef.backdropClick().subscribe(() => {
        this.triggerCloseButton(dialogRef);
      });
    });
  }

  private triggerCloseButton(dialogRef: any) {
    // Try to find ANY close button inside dialog
    const container = document.querySelector('.mat-mdc-dialog-container');

    if (!container) {
      // dialogRef.close();
      return;
    }

    // Common close button patterns
    const selectors = [
      'button[mat-dialog-close]',
      'button[matdialogclose]',
      '.close, .close-btn'
    ]; ``

    for (const sel of selectors) {
      const btn = container.querySelector(sel);
      if (btn) {
        (btn as HTMLElement).click();
        return;
      }
    }

    // Fallback if no button found
    // dialogRef.close();
  }

  waitForStylesheet(href: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const links = Array.from(document.styleSheets)
        .map(s => (s as CSSStyleSheet).href)
        .filter(Boolean);
      if (links.includes(location.origin + '/' + href)) {
        resolve();
      } else {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => resolve();
        link.onerror = () => reject(`Stylesheet failed to load: ${href}`);
        document.head.appendChild(link);
      }
    });
  }

}
